import React from "react";

// أيقونات بسيطة (خط رفيع، بدون تعبئة) تستخدم في أي مكان محتاج توضيح بصري بدون الاعتماد على مكتبة خارجية.
// كلها بتقبل className عادي عشان تتحكم بالحجم واللون من بره.

const base = { fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round" };

export const IconLocation = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" {...base} {...props}>
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 1 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

export const IconClock = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" {...base} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 3" />
  </svg>
);

export const IconRing = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" {...base} {...props}>
    <circle cx="12" cy="15" r="6" />
    <path d="M9 9l3-6 3 6" />
  </svg>
);

export const IconGraduation = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" {...base} {...props}>
    <path d="M22 9 12 5 2 9l10 4 10-4Z" />
    <path d="M6 11v5c0 1.5 3 3 6 3s6-1.5 6-3v-5" />
  </svg>
);

export const IconBriefcase = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" {...base} {...props}>
    <rect x="3" y="7" width="18" height="13" rx="2" />
    <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </svg>
);

export const IconMoonStar = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" {...base} {...props}>
    <path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z" />
  </svg>
);

export const IconRuler = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" {...base} {...props}>
    <path d="m3 17 5-5 3 3 8-8" />
    <path d="M14 4h4v4M18 8v8H6" />
  </svg>
);

export const IconScale = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" {...base} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M8 13a4 4 0 0 0 8 0" />
  </svg>
);

export const IconUsers = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" {...base} {...props}>
    <circle cx="9" cy="8" r="3" />
    <path d="M2 20c0-3 3-5 7-5s7 2 7 5" />
    <circle cx="17" cy="8" r="2.5" />
    <path d="M17 12c2.5 0 5 1.5 5 4" />
  </svg>
);

export const IconChat = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" {...base} {...props}>
    <path d="M21 11.5a8.38 8.38 0 0 1-8.5 8.4H12a8.3 8.3 0 0 1-4-1L3 20l1.1-5A8.4 8.4 0 0 1 12 3a8.38 8.38 0 0 1 9 8.5Z" />
  </svg>
);

export const IconShieldBlock = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" {...base} {...props}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
    <path d="m9.5 9.5 5 5M14.5 9.5l-5 5" />
  </svg>
);

export const IconShieldCheck = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" {...base} {...props}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);

export const IconSparkle = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" {...base} {...props}>
    <path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2 2M16 16l2 2M6 18l2-2M16 8l2-2" />
  </svg>
);

export const IconMail = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" {...base} {...props}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3 7 9 6 9-6" />
  </svg>
);

export const IconLock = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" {...base} {...props}>
    <rect x="4" y="11" width="16" height="9" rx="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </svg>
);

export const IconUser = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" {...base} {...props}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c0-4 4-6 8-6s8 2 8 6" />
  </svg>
);

export const IconPhone = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" {...base} {...props}>
    <path d="M6 3h3l2 5-2.5 1.5a11 11 0 0 0 5 5L15 12l5 2v3a2 2 0 0 1-2 2A16 16 0 0 1 4 5a2 2 0 0 1 2-2Z" />
  </svg>
);

export const IconCalendar = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" {...base} {...props}>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M3 10h18M8 3v4M16 3v4" />
  </svg>
);

export const IconCheck = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" {...base} {...props}>
    <path d="m5 12 5 5 9-10" />
  </svg>
);

export const IconHeart = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" {...base} {...props}>
    <path d="M12 20s-7-4.5-9.5-9A5 5 0 0 1 12 6a5 5 0 0 1 9.5 5c-2.5 4.5-9.5 9-9.5 9Z" />
  </svg>
);
